import { render, staticRenderFns } from "./WebTools.vue?vue&type=template&id=b071741e&scoped=true"
import script from "./WebTools.vue?vue&type=script&lang=js"
export * from "./WebTools.vue?vue&type=script&lang=js"
import style0 from "./WebTools.vue?vue&type=style&index=0&id=b071741e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b071741e",
  null
  
)

export default component.exports